import React, {useState, useEffect} from 'react';
import { styled } from '@mui/material/styles';
import {useTranslation} from 'react-i18next';
import {
  Button,
  Divider
} from "@mui/material";
import { Typography, Paper } from '@mui/material';
import clsx from 'clsx';

const PREFIX = 'EntityLinked';

const classes = {
  fullWidthElement: `${PREFIX}-fullWidthElement`,
  paddingRoot: `${PREFIX}-paddingRoot`,
  title: `${PREFIX}-title`,
  subTitle: `${PREFIX}-subTitle`,
  contentContainer: `${PREFIX}-contentContainer`,
  buttonContainer: `${PREFIX}-buttonContainer`,
  actionButton: `${PREFIX}-actionButton`,
  buttonsContainer: `${PREFIX}-buttonsContainer`,
  marginTop: `${PREFIX}-marginTop`,
  spheresContainer: `${PREFIX}-spheresContainer`,
  entityLogo: `${PREFIX}-entityLogo`,
  entityContainer: `${PREFIX}-entityContainer`,
  divider: `${PREFIX}-divider`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.fullWidthElement}`]: {
    width: '100%',
    textAlign: 'center',
    paddingTop: '1rem',
  },

  [`& .${classes.paddingRoot}`]: {
    padding: '1rem',
  },

  [`& .${classes.title}`]: {
    marginBottom: '0.5rem !important',
  },

  [`& .${classes.subTitle}`]: {
    marginBottom: '1.5rem !important'
  },

  [`& .${classes.contentContainer}`]: {
    [theme.breakpoints.up('sm')]: {
      width: '80%',
    },
    margin: '0 auto'
  },

  [`& .${classes.buttonContainer}`]: {
    display: 'flex',
    justifyContent: 'end',
    [theme.breakpoints.up('sm')]: {
      width: '90%',
    },
  },

  [`& .${classes.actionButton}`]: {
    float: 'right',
  },

  [`& .${classes.buttonsContainer}`]: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around'
  },

  [`& .${classes.marginTop}`]: {
    marginTop: '1rem'
  },

  [`& .${classes.spheresContainer}`]: {
    height: '400px',
    margin: '1rem 0',
    overflowY: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    paddingTop: '1rem',
  },

  [`& .${classes.entityLogo}`]: {
    width: '80px',
    height: '80px'
  },

  [`& .${classes.entityContainer}`]: {
    width: '150px',
    height: '120px',
    cursor: 'pointer',
    marginBottom: '0.5rem'
  },

  [`& .${classes.divider}`]: {
    // marginTop: '2rem',
    // marginBottom: '2rem',
  }
}));

const EntityLinked = (props) => {
  const {t} = useTranslation();
  const [linkEntity, setLinkEntity] = useState(null);

  useEffect(() => {
    if (linkEntity === null || ( linkEntity && props.exparience.entityId.length === 0)) {
      props.setIsValid(false);
    }
    else
      props.setIsValid(true);
  }, [linkEntity, props.exparience.entityId])

  if (props.currentStep >= 3) {
    return (
      <Root>
        <div className={clsx(classes.fullWidthElement, classes.paddingRoot)}>
          <Typography variant="h5" className={classes.title}>{t('exparienceCreateForm.entityTitle')}</Typography>
          <Typography variant="body2"className={classes.subTitle}>{t('exparienceCreateForm.entitySubTitle')}</Typography>
          <div className={classes.contentContainer}>
            <div className={classes.buttonsContainer}>
              <Button
                variant="contained"
                color="primary"
                onClick={e => setLinkEntity(true)}
                style={{
                  border: linkEntity && '1px solid white',
                  opacity: linkEntity === false && '0.5',
                }}
              >
                {t('exparienceCreateForm.yes')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                style={{
                  border: linkEntity === false && '1px solid white',
                  opacity: linkEntity && '0.5',
                }}
                onClick={e => {
                  setLinkEntity(false);
                  props.setNewExparience({...props.exparience, entity: null, entityId: '', entityName: ''})
                  props.handleNextStep(5);
                }}
              >
                {t('exparienceCreateForm.no')}
              </Button>
            </div>
            {linkEntity &&
              <div className={classes.marginTop}>
                <Typography variant="h5">{t('exparienceCreateForm.entitySelect')}</Typography>
                <Paper elevation={20} className={classes.spheresContainer}>
                  {props.fetchedEntities.map(entity => {
                    return (
                      <div
                        key={entity.id}
                        className={classes.entityContainer}
                        style={{
                          border: entity.id === props.exparience.entityId && '1px solid white',
                          opacity: (props.exparience.entityId.length !== 0 && entity) && entity.id !== props.exparience.entityId && '0.2',
                        }}
                        onClick={e => {
                          props.setNewExparience({...props.exparience, entity, entityId: entity.id, entityName: entity.name})
                        }}
                      >
                        <img
                          id="entityLogo"
                          className={classes.entityLogo}
                          alt={entity.name}
                          src={entity.logo}
                        />
                        <Typography variant="body1">{entity.name}</Typography>
                      </div>
                    )})
                  }
                </Paper>
              </div>
            }
          </div>
          {props.currentStep === 3 && linkEntity &&
            <div className={classes.buttonContainer}>
              <Button
                variant="contained"
                color="primary"
                disabled={props.exparience.entityId.length === 0 && props.exparience.entity === null ? true : false}
                onClick={e => props.handleNextStep(5)}
                className={classes.actionButton}
              >
                {t('exparienceCreateForm.continueButton')}
              </Button>
            </div>
          }
        </div>
        <Divider light className={classes.divider}/>
      </Root>
    );
  } else {
    return null;
  }
}

export default EntityLinked;